<i18n>
{
"en": {
  "MANAGELOG": "Manage Log",
  "LOADING": "Loading...",
  "CHOOSEFILTERBY": "Choose Filer By",
  "FILTERBYEVENT": "Filter by event",
  "PICKARANGE": "Pick a range",
  "PAGE": "Page",
  "DATEANDTIME": "Date and Time",
  "IPADDRESS": "IP Address",
  "EVENTTYPE": "Event Type",
  "DATE": "Date",
  "ABSENCE": "Absence",
  "BUS": "Bus",
  "CONFIGURATION": "Configuration",
  "DRIVER": "Driver",
  "GUARDIAN": "Guardian",
  "INCIDENT": "Incident",
  "LOG": "Log",
  "MESSAGE": "Message",
  "ROLE": "Role",
  "ROUTE": "Route",
  "STUDENT": "Student",
  "SUPERVISOR": "Supervisor",
  "USER": "User",
  "VIOLATION": "Violation",
  "VIEW": "View",
  "ADD/UPDATE": "Save",
  "CHANGESTATUS": "Change Status",
  "DELETE": "Delete",
  "IMPORT": "Import",
  "SEND": "Send",
  "REGISTRATION": "Registration",
  "CLONE": "Clone",
  "SAVETAG": "Save Tag",
  "LOGIN": "Login",
  "SAVE": "Save",
  "STATUS": "Status",
  "SAVE_TAG": "Save Tag",
  "FILTERBYACTION": "Filter by action",
  "LOGOUT": "Logout"
},
"ar": { 
  "MANAGELOG": "إدارة السجل",
"LOADING": "جار التحميل...",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "FILTERBYEVENT": "تصفية حسب الحدث", 
  "PICKARANGE": " اختيار مجموعة",
  "PAGE": "صفحة",
  "DATEANDTIME": " التاريخ والوقت",
  "IPADDRESS": " IP عنوان", 
  "EVENTTYPE": "نوع الحدث",
  "DATE": "تاريخ",
  "ABSENCE": "غياب",
  "BUS": "حافلة",
  "CONFIGURATION": "ترتيب",
  "DRIVER": "سائق",
  "GUARDIAN": "ولي الامر",
  "INCIDENT": "حادث",
  "LOG": "سجل",
  "MESSAGE": "رسالة",
  "ROLE": "وظيفة",
  "ROUTE": "خط السير",
  "STUDENT": "طالب",
  "SUPERVISOR": "المشرفة",
  "USER": "المستعمل",
  "VIOLATION": "انتهاك",
  "VIEW": "عاين",
  "ADD/UPDATE": "حفظ",
  "CHANGESTATUS": "تغيير الوضع",
  "DELETE": "حذف",
  "IMPORT": "استيراد",
  "SEND": "إرسال",
  "REGISTRATION": "التسجيل",
  "CLONE": "نسخ",
  "SAVETAG": "حفظ العلامة",
  "LOGIN": "تسجيل الدخول",
  "SAVE": "حفظ",
  "STATUS": "الحالة",
  "SAVE_TAG": "حفظ العلامة",
  "FILTERBYACTION": "التصفية بحسب الإجراء",
  "LOGOUT": "الخروج"
}
}
 
</i18n>
<template>
    <div id="log">
        <el-card class="card-border" ref="card" :body-style="{ padding:0 }">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;" class="title">{{$t('MANAGELOG')}}</span>
            </div>
            <el-row>
            <el-col :span="6">
              <VuePerfectScrollbar  ref="Scrollbar" v-loading="loading" :element-loading-text="$t('LOADING')">
                  <div class="scroll-border" :style="{ height: listHeight + 'px' }">
                  <el-button  class="list" :key="key" v-for="(user, key) in users" @click="loadUserLogs(user.PersonID)" v-bind:class="[user.PersonID == userID ? 'active' : '']">
                    <img :src="getAsset(user.ImagePath, 'user')"   class="img-circle" style="width: 50px;">
                    {{_FullName({NameEN: user.FullName_EN, NameAR: user.FullName_AR})}} <el-tag type="primary" v-if="user.Role">{{user.Role}}</el-tag><br/>
                  </el-button>
                  </div>
                </VuePerfectScrollbar>
            </el-col>
            <el-col :span="18">
            <div class="filters" ref="filter">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <el-select @change="changedFilter"  v-model="filter" :placeholder="$t('CHOOSEFILTERBY')">
                            <el-option
                                v-if="item.value!=active_filter"
                                :key="index" 
                                v-for="(item, index) in options"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="5"  v-if="active_filter=='event'">
                        <el-select :disabled="loading"  v-model="Controller" value-key="controller" :placeholder="$t('FILTERBYEVENT')" clearable  @change="getUserLogs(userID, true)">
                          <el-option
                            v-for="(item, key) in events"
                            :key="key"
                            :label="$t(item.controller.toUpperCase())"
                            :value="item">
                          </el-option>
                        </el-select>     
                      </el-col>
                      <el-col :span="5"  v-if="Controller.methods!=undefined && active_filter=='event'">
                        <el-select :disabled="loading" @change="getUserLogs(userID, true)" v-model="Action" :placeholder="$t('FILTERBYACTION')" clearable>
                          <el-option
                            :key="key" 
                            v-for="(item, key) in Controller.methods"
                            v-if="key != 'VIEW'"
                            :label="$t(key.toUpperCase())"
                            :value="item">
                          </el-option>
                        </el-select>         
                      </el-col>                    
                    <el-col :span="5"  v-if="active_filter=='date'">
                      <el-date-picker
                        v-model="date"
                        type="daterange"
                        :picker-options="pickerOption"
                        @change="getUserLogs(userID, true)"
                        :placeholder="$t('PICKARANGE')">
                      </el-date-picker>    
                    </el-col>
                </el-row>
            </div>              
            <el-table
               v-loading="loading || new_page"
                :element-loading-text="$t('LOADING')"
                :data="listLogs"
                :height="tableHeight"
                stripe
                style="width: 100%">

                <el-table-column
                    :label="$t('PAGE')"
                >
                    <template slot-scope="scope">
                        <el-button size="mini" :disabled="!isAllowed(scope.row.Controller === 'configuration' ? 'index' : scope.row.Method, scope.row.Module + '/' + scope.row.Controller)" @click="logPath(scope.row)" class="el-button" v-text="logPage(scope.row.Controller, scope.row.Method)"></el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="Timestamp"
                    :label="$t('DATEANDTIME')"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('IPADDRESS')"
                >
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button size="mini" type="[!IsBanned(scope.row) ? 'primary' : 'danger']" @click="IpBan(scope.row)" :disabled="scope.row.UserID == loggedInUserID" v-text="scope.row.IPAddress"></el-button>
                            <el-button size="mini"  type="primary" @click="IpBan(scope.row)" :disabled="scope.row.UserID == loggedInUserID"><i style="font-size:13px" class="fa fa-ban"></i></el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div style="padding:10px" ref="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[50, 70, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next"
                :total="totalLogs">
              </el-pagination>
            </div>            
            </el-col>            
            </el-row>
        </el-card>
    </div>
</template>

<script>
  
  import Vue from 'vue'
  import qs from 'qs'
  import _ from 'lodash'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import axios from 'axios'
  export default {
    components: {VuePerfectScrollbar},
    data () {
      return {
        filter: null,
        users: [],
        userID: '',
        loggedInUserID: 1,
        active_filter: 'date',
        logs: {},
        events: [],
        banned: [],
        loading: true,
        new_page: false,
        filteredRoles: [],
        currentRow: null,
        Controller: '',
        Action: '',
        tableHeight: 0,
        listHeight: 0,
        totalLogs: 0,
        currentPage: 1,
        visitedPage: [1],
        date: [null, null],
        limit: 50,
        pickerOption: {
          disabledDate (time) {
            return time.getTime() >= Date.now()
          }
        }
      }
    },
    mounted () {
      this.switchLanguage()
      this.listHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.tableHeight = this.listHeight - this.$refs.filter.offsetHeight - this.$refs.pagination.offsetHeight
      this.loadInitialData()
    },
    computed: {
      listLogs () {
        return this.logs[this.currentPage - 1]
      },
      options () {
        let options = [{
          value: 'event',
          label: this.$t('EVENTTYPE')
        }, {
          value: 'date',
          label: this.$t('DATE')
        }]
        return options
      }
    },
    methods: {
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getUserLogs(this.userID)
      },
      handleSizeChange (val) {
        this.limit = val
        this.logs = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getUserLogs(this.userID)
      },
      logPage (controller, method) {
        if (localStorage.getItem('lang') === 'en') return this.$t(controller.toUpperCase()) + ' ' + this.$t(method.toUpperCase())
        return this.$t(method.toUpperCase()) + ' ' + this.$t(controller.toUpperCase())
      },
      getUserLogs (userID, filter = false) {
        this.userID = userID
        let self = this
        if (filter) {
          self.currentPage = 1
          self.visitedPage = [1]
          self.new_page = true
          self.logs = {}
        }
        if (self.logs[self.currentPage - 1] !== undefined) return
        this.$http.get('/log/' + userID + '?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1)).then(function (response) {
          Vue.set(self.logs, self.currentPage - 1, response.data.logs)
          self.new_page = self.loading = false
          self.totalLogs = response.data.total
        }).catch(function (response) {})
      },
      loadUserLogs (userID) {
        if (this.userID === userID) return
        this.loading = true
        this.logs = {}
        this.getUserLogs(userID)
      },
      bindCurrentFilters () {
        let data = {filters: []}
        switch (this.active_filter) {
          case 'event': data.filters['Event'] = this.Controller.controller ? this.Controller.controller.toLowerCase() : this.Controller.controller
            if (this.Action !== '') data.filters['Action'] = this.Action ? this.Action.toLowerCase() : this.Action
            break
          case 'date':
            if (_.isNull(this.date[0]) && _.isNull(this.date[1])) break
            data.filters.Date = {}
            data.filters.Date.min = this.$moment(this.date[0]).format('YYYY-MM-DD')
            data.filters.Date.max = this.$moment(this.date[1]).format('YYYY-MM-DD')
            break
        }
        return data
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
        let load = false
        if (!_.isNull(this.date[0]) && !_.isNull(this.date[1])) load = true
        if (load) {
          this.date = [null, null]
          this.getUserLogs(this.userID, true)
        }
      },
      loadInitialData () {
        let self = this
        axios.all([this.$http.get('/user?ref=log'), this.$http.get('/role/null')])
          .then(axios.spread(function (users, events) {
            self.users = users.data
            self.userID = self.users[0].PersonID
            self.getUserLogs(self.userID)
            self.events = events.data
          })).catch(function (response) {
            console.log(response)
          })
      },
      logPath (item) {
        if (item.Method === 'login' || item.Method === 'logout') return '#'
        let skipCtrls = ['configuration']
        let itemValue = skipCtrls.indexOf(item.Controller) < 0 ? '/' + item.ItemValue : ''
        this.$router.push('/' + item.Module + '/' + item.Controller + itemValue)
      },
      IsBanned (item) {
        if (this.banned[item.UserID].indexOf(item.IPAddress) < 0) return false
        return true
      },
      IpBan (item) {
        let IPIndex = this.banned[item.UserID].indexOf(item.IPAddress)
        let status = IPIndex < 0 ? 1 : 0
        let self = this
        this.$http.post('admin/log/ip_ban', {UserID: item.UserID, IPAddress: item.IPAddress, status: status}).then(function (response) {
          if (status !== 1) return self.banned[item.UserID].splice(IPIndex, 1)
          self.banned[item.UserID].push(item.IPAddress)
        }).catch(function (response) {
          console.log(response)
        })
      }
    }
  }
</script>
<style>
.text-transform {text-transform:capitalize;}
#log .el-tag.el-tag--primary {float: right;}
#rtl #log .el-tag.el-tag--primary {float: left;}
</style>



// WEBPACK FOOTER //
// Log.vue?3613ab7a